import React from "react";
import Webcam from "react-webcam";
import jsQR from "jsqr";
import { useAppContext } from "../../context/appContext";

const QRScanner = ({ qrCodeUrl, setQrCodeUrl }) => {
    const { isCameraActive, setIsCameraActive } = useAppContext();
    const webcamRef = React.useRef(null);

    // STOP STREAM FUNCTION
    const stopStream = React.useCallback(() => {
        const video = webcamRef.current?.video;
        const stream = video?.srcObject;
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
            console.log("Camera stopped by QRScanner cleanup");
        }
    }, []);

    // STOP CAMERA WHEN CAMERA STATE CHANGES
    React.useEffect(() => {
        if (!isCameraActive) stopStream();
    }, [isCameraActive, stopStream]);

    // STOP CAMERA ON UNMOUNT
    React.useEffect(() => {
        return () => stopStream();
    }, [stopStream]);


    // Capture logic
    const capture = React.useCallback(() => {
        if (!webcamRef.current) return;

        const imageSrc = webcamRef.current.getScreenshot();
        if (!imageSrc) return;

        const img = new Image();
        img.src = imageSrc;
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);

            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const code = jsQR(imageData.data, imageData.width, imageData.height);

            if (code) {
                setQrCodeUrl(code.data);
                setIsCameraActive(false);
            }
        };
    }, []);

    React.useEffect(() => {
        if (!isCameraActive) return;
        const interval = setInterval(capture, 1000);
        return () => clearInterval(interval);
    }, [capture, isCameraActive]);

    return (
        <div className="cam-container w-full" style={{ backgroundColor: "black", minHeight: "120px" }}>
            {
                isCameraActive &&
                <Webcam
                    className="w-full"
                    style={{ height: "100%", backgroundColor: "black" }}
                    ref={webcamRef}
                    screenshotFormat="image/png"
                    videoConstraints={{ facingMode: "environment" }}
                />
            }
        </div>
    );
};

export default QRScanner;